export const ROOT_KEY = 'search';
